export const safeText = (v: string = "") => {
  return v
    .split("")
    .map((letter, index) => {
      if (index === 0 || index === v.length - 1) return letter;
      return "*";
    })
    .join("");
};

export const safeRealName = (v: string = "") => {
  if (v.length <= 1) return v;
  const arr = v.split("");
  arr[1] = "*";
  return arr.join("");
};

export const safeBankNumber = (v: string = "") => {
  return (v || "").replace(/^\d+(\d{4})$/g, ($1, $2) => `**** **** **** ${$2}`);
};

export const hideText = (
  val: string = "",
  flag: string = "",
  def: string = "",
) => {
  if (flag && !val) {
    return def.replace(/[\d\D]/g, "*");
  }
  if (val && val.length > 0 && flag) {
    return val.replace(/[\d\D]/g, "*");
  }
  return val;
};
